import clsx from 'clsx';
import { Fragment, FunctionComponent } from 'react';
import { SelectionBarItem } from './SelectionBarItem';
import { ReactNode } from 'react';
import styles from './SelectionBar.module.scss';

export interface SelectionBarOption<T = string> {
    id: T;
    name: ReactNode;
    selectedBackgroundColor?: string;
}

export interface SelectionBarProps {
    options: Array<SelectionBarOption<string>>;
    selectedId: string;
    selectedTotalRecords?: number;
    background?: string;
    borderColor?: string;
    className?: string;
    onSelect: (id: string) => void;
}

export const SelectionBar: FunctionComponent<SelectionBarProps> = ({
    options,
    selectedId,
    selectedTotalRecords,
    background,
    borderColor,
    className,
    onSelect
}) => {
    const renderLabel = (option: SelectionBarOption<string>) => {
        if (option.id === selectedId && selectedTotalRecords !== undefined) {
            return (
                <>
                    {option.name} ({selectedTotalRecords})
                </>
            );
        }
        return option.name;
    };

    const containerStyle = {
        ...(background && { backgroundColor: background }),
        ...(borderColor && { border: `1px solid ${borderColor}` })
    };

    const buttons = options.map(option => {
        return (
            <Fragment key={option.id}>
                <div>
                    <SelectionBarItem
                        label={renderLabel(option)}
                        selected={option.id === selectedId}
                        onClick={() => {
                            onSelect(option.id);
                        }}
                        selectedBackgroundColor={option.selectedBackgroundColor}
                    />
                </div>
            </Fragment>
        );
    });

    return (
        <div
            className={clsx(styles.container, className)}
            style={containerStyle}
        >
            {buttons}
        </div>
    );
};

export default SelectionBar;
